<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-detail-config-card">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ panel.graph }}</span>
    </v-row>
    <v-col class="com-pc-card-contents">
      <v-row no-gutters>
        <div class="center" v-if="dispGraph()">
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="scalMode === true"
            @click="scalMode = false"
            >{{ btn.zoomout }}</v-btn
          >
          <v-btn
            tile
            depressed
            small
            class="mt-1"
            color="success"
            min-width="50px"
            max-width="50px"
            :outlined="scalMode === false"
            @click="scalMode = true"
            >{{ btn.zoomin }}</v-btn
          >
        </div>
      </v-row>
    </v-col>
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ panel.contents }}</span>
      <span class="com-pc-legend-btn" v-if="dispGraph()">
        <v-btn
          depressed
          x-small
          class="ma-1"
          color="orange"
          max-width="70px"
          dark
          :outlined="!isLegendDisp"
          @click="isLegendDisp = !isLegendDisp"
        >
          {{ btn.legend }}
          <span v-if="isLegendDisp">{{ btn.legendOn }}</span>
          <span v-else>{{ btn.legendOff }}</span>
        </v-btn>
      </span>
    </v-row>
    <v-col class="com-pc-card-contents">
      <v-checkbox
        v-model="obsDispStatus.info"
        :label="contents.info"
        class="ma-0"
        hide-details
        v-if="this.detailInfoList && this.detailInfoList.length > 0"
      ></v-checkbox>
      <v-checkbox
        v-model="obsDispStatus.obsGraph"
        :label="contents.wtrQualGraph"
        class="ma-0"
        hide-details
      ></v-checkbox>
      <v-row no-gutters v-if="dispGraph()">
        <v-col>
          <div class="center">{{ panel.leftGraph }}</div>
          <div v-for="(item, idx) in graph" :key="'left' + idx" class="center">
            <v-btn
              depressed
              small
              class="ml-1 mt-1"
              color="success"
              width="80px"
              :outlined="
                !(obsDispStatus.graphSwitch.leftAxisGraph == item.code)
              "
              :disabled="!obsDispStatus.obsGraph"
              @click="obsDispStatus.graphSwitch.leftAxisGraph = item.code"
              >{{ item.name }}</v-btn
            >
          </div>
        </v-col>
        <v-col>
          <div class="center">{{ panel.rightGraph }}</div>
          <div v-for="(item, idx) in graph" :key="'right' + idx" class="center">
            <v-btn
              depressed
              small
              class="ml-1 mt-1"
              color="success"
              width="80px"
              :outlined="
                !(obsDispStatus.graphSwitch.rightAxisGraph == item.code)
              "
              :disabled="!obsDispStatus.obsGraph"
              @click="obsDispStatus.graphSwitch.rightAxisGraph = item.code"
              >{{ item.name }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <v-checkbox
        v-model="obsDispStatus.valuesList"
        :label="contents.valuesList"
        class="ma-0"
        hide-details
      ></v-checkbox>
    </v-col>
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ panel.sns }}</span>
    </v-row>
    <v-col class="com-pc-card-contents">
      <tm-detail-sns></tm-detail-sns>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]水質 表示切替カード
 * TmWtrQualDetailConfig.vue
 * @author ILUKE
 */
import TmDetailSns from "./TmDetailSns.vue";
export default {
  name: "tm-wtr-qual-detail-config",
  components: {
    TmDetailSns,
  },
  data() {
    return {
      panel: {
        graph: "表示切替",
        legend: "凡例",
        contents: "内容表示",
        leftGraph: "左軸",
        rightGraph: "右軸",
        sns: "SNS投稿",
      },
      contents: {
        info: "お知らせ情報",
        wtrQualGraph: "水質グラフ",
        valuesList: "観測値一覧",
      },
      btn: {
        zoomout: "全体",
        zoomin: "拡大",
        legend: "凡例",
        legendOn: "(on)",
        legendOff: "(off)",
      },
      graph: [
        { name: "水温", code: 0 },
        { name: "pH", code: 1 },
        { name: "DO", code: 2 },
        { name: "導電率", code: 3 },
        { name: "濁度", code: 4 },
        { name: "ｱﾝﾓﾆｳﾑｲｵﾝ", code: 5 },
        { name: "塩分濃度", code: 6 },
        { name: "COD", code: 7 },
      ],
    };
  },
  computed: {
    /** 水質情報 */
    tmWtrQualList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /** 拡縮表示設定 */
    scalMode: {
      get() {
        return this.$store.state.Telemeter.scalMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalMode", val);
      },
    },
    /** 凡例表示状態 */
    isLegendDisp: {
      get() {
        return this.$store.state.Telemeter.isLegendDisp;
      },
      set(val) {
        this.$store.commit("Telemeter/setLegendDisp", val);
      },
    },
    /** コンテンツ切替 */
    obsDispStatus: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus;
      },
    },
    /** お知らせ情報 */
    detailInfoList: {
      get() {
        return this.$store.state.map.information;
      },
    },
  },
  methods: {
    /**
     * グラフ表示判定
     */
    dispGraph() {
      if (
        this.tmWtrQualList.length !== 0 &&
        this.tmWtrQualList.graph.hour.value.length > 0
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.com-pc-card-header {
  .com-pc-legend-btn {
    position: absolute;
    right: 0;
  }
}
</style>
